import UploadImage from '@/components/upload-image/index.vue';
import PurchaseConfirmAnnouncement from '@/components/purchase-confirm-announcement/purchase-confirm-announcement.vue';

import Service from '@/service/index.js';
import PurchaseBusinessService from '../../purchase-business-service.js';

export default {
  components: {
    UploadImage,
    PurchaseConfirmAnnouncement
  },
  data() {
    return {
      form: {
        files: []
      },
      purchaseFileType: []
    };
  },
  created() {
    this.id = this.$route.query.id;
    Service.getSelectList('PURCHASE_FILE').then(res => {
      if (res && res.code === '0') {
        this.purchaseFileType = [res.data.find(v => v.value === '公告照片')];
        this.initFiles();
      }
    });
  },
  methods: {
    initFiles () {
      this.purchaseFileType.forEach(item => {
        this.form.files.push({
          projectFileType: Number(item.code),
          title: item,
          filePaths: [],
          defaultImage: [],
          inputValue: null
        });
      });
    },
    fileRules (item) {
      let required = true;
      if (item.projectFileType === 6 || item.projectFileType === 7) {
        required = false;
      }
      return {
        required: required,
        message: '请上传公告照片',
        trigger: 'change'
      };
    },
    uploadImage (index, event) {
      this.form.files[index].filePaths = event;
      if (event.length) {
        this.form.files[index].inputValue = event.length;
      } else {
        this.form.files[index].inputValue = null;
      }
    },
    saveAnnouncementInfo (files) {
      PurchaseBusinessService.saveAnnouncementInfo({
        purchaseId: this.id,
        files: files
      }).then(res => {
        if (res && res.code === '0') {
          this.$router.back();
        } else if (res && res.reason) {
          errorMessage(res && res.reason);
        } else {
          errorMessage( '上传公告照片失败');
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('上传公告照片失败');
        }
      });
    },
    previousStep () {
      this.$router.back();
    },
    submit() {
      this.$refs['attachmentForm'].validate(valid => {
        if (valid) {
          const files = [];
          this.form.files.forEach(item => {
            const filePaths = [];
            item.filePaths.forEach(obj => {
              filePaths.push(obj.sourceImgUrl);
            });
            files.push({
              imgEnumType: item.projectFileType,
              urls: [...filePaths]
            });
          });
          this.$confirm('确定要提交公告照片？提交后不可修改', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.saveAnnouncementInfo(files);
          }).catch(() => {});
        } else {
          return false;
        }
      });
    }
  }
};
